import 'intl-pluralrules'
import React from 'react'
import { createRoot } from 'react-dom/client'
import ChainedBackend from 'i18next-chained-backend'
import resourcesToBackend from 'i18next-resources-to-backend'
import Icon from '@roo/roo/Icon'
import locale from '@roo/roo/locale'
import locale2 from '@roo/roo/locale'
import zhHK from '@roo/roo/locale/lang/zh-TW'
import zh from '@roo/roo/locale/lang/zh-CN'
import en from '@roo/roo/locale/lang/en-US'
import ar from '@roo/roo/locale/lang/ar'
import ptBR from '@roo/roo/locale/lang/pt-BR'
import rooPlusLocale from '@roo/roo-plus/locale'
import rooPlusZhHK from '@roo/roo-plus/locale/lang/zh-TW'
import rooPlusZh from '@roo/roo-plus/locale/lang/zh-CN'
import rooPlusEn from '@roo/roo-plus/locale/lang/en-US'
import rooPlusAr from '@roo/roo-plus/locale/lang/ar'
import localeH5 from '@roo/roo-mobile/locale'
import zhHKH5 from '@roo/roo-mobile/locale/lang/zh-TW'
import zhH5 from '@roo/roo-mobile/locale/lang/zh-CN'
import enH5 from '@roo/roo-mobile/locale/lang/en-US'
import arH5 from '@roo/roo-mobile/locale/lang/ar-SA'
import ConfigProviderPlus from '@roo/roo-plus/ConfigProviderPlus'
import ConfigProvider from '@roo/roo/ConfigProvider'
import keetaLocaleZhHK from '@roo/roo-lastest/locale/lang/zh-TW'
import keetaLocaleZh from '@roo/roo-lastest/locale/lang/zh-CN'
import keetaLocaleEn from '@roo/roo-lastest/locale/lang/en-US'
import keetaLocaleAr from '@roo/roo-lastest/locale/lang/ar'
import keetaLocalePtBR from '@roo/roo-lastest/locale/lang/pt-BR'

import { i18nClient } from '@sailor/i18n-web'
import OpenAPIBackend from '@sailor/i18n-web-openapi-backend'
import PortalTool from '@RootCommon/components/PortalTool'
import { getLanguage, getDirection, initCompass, getCityId, getRegionByCookie, i18nFetchResourceJson } from '@RootCommon/utils'
import { initUtils, isInApp } from '@RootCommon/utils/h5PC'
import { loadVconsole } from '@RootCommon/utils/h5dev'
import '@sailor/keeta-design-pc/theme/default/index.css'
import '@roo/roo/theme/default/index.css'
import '@/common/assets/styles/index.less'
import '@sailor/keeta-design-pc/theme/default/index.css'
import '@sailor/keeta-design/theme/default/index.css'
import '@/common/assets/styles/allRooMobileStyle.js'
import i18nConfig from '../.i18n.config.json'
import resources from './common/locales/resources'
import Root from './router'
import HyperCache from '@sailor/hyperCache'
import { registerSw } from './registerSw'
import { setCompassRegion } from '@sailor/compass'
import WebVitalsSDK from '@sailor/web-vitals-sdk'
import { keetaLocale } from '@sailor/keeta-design-pc'
// 初始化SDK
new WebVitalsSDK({
  debug: false,
  // 性能配置 - 为false时需要手动调用sdk.report()
  realTimeReport: true,
  // 自定义上报函数
  onReport: async (data: any) => {
    try {
      if (window.parent && window.parent !== window) {
        const messageData = {
          type: 'WEB_VITALS_REPORT',
          data,
          source: 'APP_SHOP', // 业务方向
          subSource: 'app/shop', // opc的代码二级目录，如果是其他工程可以填业务子方向
        }
        // 使用原生 postMessage 向父页面发送数据
        window.parent.postMessage(messageData, '*')
      } else {
        console.log('当前页面不在 iframe 中，跳过 postMessage 发送')
      }
    } catch (error) {
      console.log('Web Vitals SDK: Reported metrics error', error)
    }
  },
})

const AWP_DEPLOY_ENV = process.env.AWP_DEPLOY_ENV
const BUILD_ENV = process.env.BUILD_ENV
const isProdEnv = AWP_DEPLOY_ENV === 'production' || AWP_DEPLOY_ENV === 'staging'

// const i18nConfig = {
//   'dest': 'App/shop/src/common/locales',
//   'namespaces': [
//     { 'name': 'shop_set_web', 'projectId': 5, 'apiKey': 'dd709595d1344094ae219064ab53f28b', 'namespaceId': 'dtu0qybsds' },
//     { 'name': 'finance_bankcardEdit', 'projectId': 5, 'apiKey': 'dd709595d1344094ae219064ab53f28b', 'namespaceId': 'a175mxahwh' },
//     { 'name': 'message_center', 'projectId': 5, 'apiKey': 'dd709595d1344094ae219064ab53f28b', 'namespaceId': '59raukmtno' },
//     { 'name': 'Merchant_open_time_web_v1', 'projectId': 5, 'apiKey': 'dd709595d1344094ae219064ab53f28b', 'namespaceId': 'clhluivvfp' },
//     { 'name': 'account_web', 'projectId': 5, 'apiKey': 'dd709595d1344094ae219064ab53f28b', 'namespaceId': 'olipmd4ssu' },
//     { 'name': 'business_status', 'projectId': 5, 'apiKey': 'dd709595d1344094ae219064ab53f28b', 'namespaceId': 'wfplz9bnb3' },
//     { 'name': 'customer_review_web', 'projectId': '5', 'apiKey': 'dd709595d1344094ae219064ab53f28b', 'namespaceId': '6g7sxko2dx' },
//     { 'name': 'Healthiness_level', 'projectId': 5, 'apiKey': 'dd709595d1344094ae219064ab53f28b', 'namespaceId': 'qcqemtsfuh' },
//     { 'name': 'Native_BasicServices', 'projectId': 5, 'apiKey': 'dd709595d1344094ae219064ab53f28b', 'namespaceId': 'utjoqvl3cc' },
//     { 'name': 'B_APP', 'projectId': '5', 'apiKey': 'dd709595d1344094ae219064ab53f28b', 'namespaceId': 'wfplz9bnb3' },
//     { 'name': 'pos_order_process', 'projectId': 5, 'apiKey': 'dd709595d1344094ae219064ab53f28b', 'namespaceId': 'o082lntk5e' },
//     { 'name': 'b_web_settle', 'projectId': 5, 'apiKey': 'dd709595d1344094ae219064ab53f28b', 'namespaceId': 'vj9dug7rtn' },
//     { 'name': 'm_web_settle', 'projectId': 6, 'apiKey': 'c8a8b802de0447359433a0aaa8e51bf8', 'namespaceId': '7pqvwxwxek' },
//     { 'name': 'web_merchants_enter', 'projectId': 6, 'apiKey': 'c8a8b802de0447359433a0aaa8e51bf8', 'namespaceId': 'iqn5xcqzxb' },
//     { 'name': 'keeta_design', 'projectId': 5, 'apiKey': 'dd709595d1344094ae219064ab53f28b', 'namespaceId': 'ex3ebkdixv' }],
// }
if (isProdEnv) {
  try {
    // st 和 线上 关闭， 观察后再看是否关闭 pwa
    // @ts-ignore
    const hyperCache = HyperCache.getInstance()
    hyperCache.turnOff() // HyperCache.turnOff()仅68版本可，69版本兼可
    console.log('hyperCache.turnOff success')
  } catch (error) {
    console.log('hyperCache.turnOff error:', error)
  }
} else {
  registerSw()
}

const region = getRegionByCookie()
setCompassRegion(region)
// 初始化region相关信息，owl、LXAnalytics等
initCompass()

// owl && owl('setTag', {
//   area: region,
//   cityId: getCityId(),
// })
// if (window.LXAnalytics) {
//   window.LXAnalytics('config', { region })
//   window.LXAnalytics('setCompass', JSON.stringify({ region, cityId: getCityId() }))
// }
// i18nFetchResourceJson && i18nFetchResourceJson()

const defaultLang = getLanguage()
const rooLocaleLangs = {
  'zh-HK': zhHK,
  'zh': zh,
  'en': en,
  'ar': ar,
  'pt-BR': ptBR,
}
const rooPlusLocaleLangs = {
  'zh-HK': rooPlusZhHK,
  'zh': rooPlusZh,
  'en': rooPlusEn,
  'ar': rooPlusAr,
}
const rooH5LocaleLangs = {
  'zh-HK': zhHKH5,
  'zh': zhH5,
  'en': enH5,
  'ar': arH5,
}
const keetaLocaleLangs = {
  'zh-HK': keetaLocaleZhHK,
  'zh': keetaLocaleZh,
  'en': keetaLocaleEn,
  'ar': keetaLocaleAr,
  'pt-BR': keetaLocalePtBR,
}
// 兼容阿语
// @ts-ignore
rooLocaleLangs[defaultLang] && locale.use(rooLocaleLangs[defaultLang])
// @ts-ignore
rooLocaleLangs[defaultLang] && locale2.use(rooLocaleLangs[defaultLang])
// @ts-ignore
rooPlusLocaleLangs[defaultLang] && rooPlusLocale.use(rooPlusLocaleLangs[defaultLang])
// @ts-ignore
rooLocaleLangs[defaultLang] && localeH5.use(rooH5LocaleLangs[defaultLang])
// @ts-ignore
keetaLocaleLangs[defaultLang] && keetaLocale.use(keetaLocaleLangs[defaultLang])
Icon.extend({
  scriptUrl: [
    // @ts-ignore
    KEETA_B_PC_ICON_URL,
    // @ts-ignore
    KEETA_B_APP_ICON_URL,
  ],
})

try {
  // eslint-disable-next-line
  owl && owl('addPoint', { position: 22 }) // 以js入口作为首次绘制时间
} catch (e) {
  console.log(e)
}


(async function () {
  i18nClient
    .use(ChainedBackend)
    .init({
      // 设置回退语言
      fallbackLng: defaultLang,
      ns: i18nConfig.namespaces.map((v: any) => v.name), // 当使用多个空间名称时，必须配置 ns，且第一个为默认空间名
      defaultNS: i18nConfig.namespaces.map((v: any) => v.name)[0], // 设置默认空间名称
      backend: {
        // @ts-ignore
        openI18nKeyRaptor: true,
        i18nKeyRaptorConfig: { // i18nKeyRaptorConfig：web 端上报相关配置
          // web 项目参数
          clientAppkey: 'com.sankuai.sailorfe.b.pc', // 项目 appkey，如 keeta M 端为：com.sankuai.sailorfe.b.pc
          region,
        },
        backends: [
          OpenAPIBackend, // 通过api获取最新语言包
          resourcesToBackend(resources as any), // 本地资源包作为兜底
        ],
        // 这里配置一下所使用的projectId和namespaceId
        backendOptions: [{
          ...i18nConfig,
          env: isProdEnv ? 'prod' : 'test',
          useFetchAsync: true,
          maxConcurrency: 3,
        }],
        // @ts-ignore
        cacheOptions: { openClearOldLanguagePackage: true },
        idc: process_env_publishIdc || 'HK', // 当前代码部署的机房
        useSailorCompass: true, // 配置后会使用罗盘获取 i18n web sdk 对应 host 域名
        autoFetchI18nApiConfig: true, // 配置后自动进行 fetchResourceJson，业务侧可以取消业务代码中的 fetchResourceJson
      },
    }, async function (err, t) {
      await initUtils()
      isInApp() && loadVconsole()
      const container = document.getElementById('root') as HTMLElement
      // TODO: StrictMode严格模式为其后代元素触发额外的检查和报告,在开发过程中组件会有多次调用问题，但仅在开发环境中运行，不会影响生产构建
      // 可删除StrictMode
      createRoot(container).render(<>
        <ConfigProvider config={{ direction: getDirection() }}>
          <ConfigProviderPlus config={{ direction: getDirection() }}>
            <Root />
          </ConfigProviderPlus>
        </ConfigProvider>
        {!BUILD_ENV ? <PortalTool /> : <></>}
      </>)
    },)
})()